// extracted by mini-css-extract-plugin
export default {"card":"styles_card__Rbhoz","spin":"styles_spin__qG9BU","image":"styles_image__L0f5G","details":"styles_details__aGONw"};